const breakpoints = {
    sm: "40em",
    md: "52em",
    lg: "64em"
};

const space = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
    xxl: 64
};

const lineHeight = {
    sm: 1,
    md: 1.5,
    lg: 2
};

const fontFamily = {
    heading: "'HeaderFont', Helvetica, Arial, sans-serif",
    body: "'BodyFont', Helvetica, Arial, sans-serif"
};

const fontSize = {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 24,
    xl: 48
};

const iconSize = {
    sm: 16,
    md: 24,
    lg: 48
};

const fontWeight = {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900
};

const radii = {
    sm: 3,
    md: 6,
    lg: 9
};

const zIndex = {
    clicklayer: 1000,
    dropdown: 1010,
    sticky: 1020,
    modal: 1030,
    popover: 1040
};

const shadow = {
    sm: "2px 2px 0 rgba(0,0,0,0.1)",
    md: "4px 4px 0 rgba(0,0,0,0.1)",
    lg: "8px 8px 0 rgba(0,0,0,0.1)"
};

const color = {
    primary: "#03a9f4",
    secondary: "#236593",
    success: "#28a745",
    info: "#17a2b8",
    warning: "#ffc107",
    error: "#dc3545",

    white: "#fff",
    gray100: "#f8f9fa",
    gray200: "#e9ecef",
    gray300: "#dee2e6",
    gray400: "#ced4da",
    gray500: "#adb5bd",
    gray600: "#868e96",
    gray700: "#495057",
    gray800: "#343a40",
    gray900: "#212529",
    black: "#000",

    bodyBg: "#fff",
    body: "#212529",
    headings: "#007bff",
    link: "#007bff",
    linkActive: "#007bff",
    linkHover: "#007bff"
};

export const theme = {
    breakpoints,
    space,
    lineHeight,
    fontSize,
    iconSize,
    fontWeight,
    fontFamily,
    radii,
    color,
    zIndex,
    shadow
};


// WEBPACK FOOTER //
// ./src/Components/theme.ts